import React from 'react';
export function HeadlineSection() {
  return <section className="w-full text-center bg-white" style={{
    padding: '28px 18px'
  }} data-id="element-78">
      <h1 className="font-bold m-0" style={{
      fontSize: '22px',
      lineHeight: 1.35,
      color: '#111111'
    }} data-id="element-79">
        <span className="font-extrabold underline" style={{
        color: '#16a34a'
      }} data-id="element-80">
          En tan solo 15 días,
        </span>{' '}
        tu hijo va a dejar de paralizarse por la presión.. y va a empezar a
        jugar con seguridad, carácter y decisión real.
      </h1>

      <p className="font-bold" style={{
      marginTop: '18px',
      fontSize: '15px',
      color: '#16a34a',
      lineHeight: 1.4
    }} data-id="element-81">
        ¿CUÁNTAS OPORTUNIDADES MÁS VA A PERDER TU HIJO POR MIEDO A EQUIVOCARSE?
      </p>

      <p style={{
      marginTop: '14px',
      fontSize: '14px',
      color: '#6b7280',
      lineHeight: 1.5
    }} data-id="element-82">
        No le falta talento. Le falta fortaleza mental. Y eso...
      </p>

      <p className="font-bold" style={{
      fontSize: '15px',
      color: '#16a34a',
      marginTop: '4px'
    }} data-id="element-83">
        se entrena.
      </p>
    </section>;
}